<div class="card-container">
  <div class="column-headings">
    <div class="heading">MARKET VALUE</div>
  </div>
  @for (entityInvestment of currentPage().data; track entityInvestment) {
    <a class="row">
      <app-entity-investment-card [entityInvestment]="entityInvestment" (cardClicked)="handleCardClicked($event)"></app-entity-investment-card>
    </a>
  }
</div>
